import { Box, Tooltip } from "@mui/material"
import { InfoOutlined } from "@mui-symbols-material/w300"
import type { ColumnDef } from "@tanstack/react-table"
import dayjs from "dayjs"
import React from "react"

import StyledChip from "@/components/common/Chip/Chip"
import type { Classification } from "@/graphql/codegen/graphql"
import { ClassificationActions } from "@/screens/ManageProducts/components/ProductClasses/components/table/ClassificationActions"

export const useProductClassificationsColumns = (): ColumnDef<Classification>[] => {
  return [
    {
      accessorKey: "productCategory",
      header: "Product Category",
      sortingFn: "alphanumeric",
      cell: ({ row }) => (
        <Box className='ml-2 flex items-center'>
          {row.original.categoryDetail?.name}
          <Tooltip title={`AS400 ID ${row.original.categoryDetail?.externalSystemId}`}>
            <InfoOutlined className='ml-2 text-gray-600' />
          </Tooltip>
        </Box>
      ),
      size: 250,
      enableSorting: true,
    },
    {
      accessorKey: "productClass",
      cell: ({ row }) => (
        <Box className='ml-2 flex items-center'>
          {row.original.name}
          <Tooltip title={`AS400 ID ${row.original?.externalSystemId}`}>
            <InfoOutlined className='ml-2 text-gray-600' />
          </Tooltip>
        </Box>
      ),
      header: "Product Class",
      sortingFn: "alphanumeric",
      size: 250,
      enableSorting: true,
    },
    {
      accessorKey: "productManager",
      header: "Product Manager",
      cell: ({ row }) => {
        const productManager = row.original?.productManager
        const label = productManager ? `${productManager?.firstName ?? ""} ${productManager?.lastName ?? ""}` : "-"

        return <Box className='ml-2 flex items-center'>{label}</Box>
      },
      sortingFn: "alphanumeric",
      enableSorting: true,
    },
    {
      accessorKey: "createdOn",
      header: "Created",
      cell: ({ row }) => {
        const classification = row.original
        return (
          <StyledChip
            label={
              <span>
                {classification.createdOn ? dayjs(classification.createdOn).format("MM/DD/YYYY") : "--/--/----"}
              </span>
            }
            classes={{
              colorDefault: "bg-gray-100",
            }}
            className='text-gray-900'
          />
        )
      },
      enableSorting: false,
    },
    {
      accessorKey: "updatedOn",
      header: "Updated",
      cell: ({ row }) => {
        const classification = row.original
        return (
          <StyledChip
            label={
              <span>
                {classification.updatedOn ? dayjs(classification.updatedOn).format("MM/DD/YYYY") : "--/--/----"}
              </span>
            }
            classes={{
              colorDefault: "bg-gray-100",
            }}
            className='text-gray-900'
          />
        )
      },
      enableSorting: false,
    },
    {
      accessorKey: "actions",
      header: "",
      cell: ({ row }) => <ClassificationActions row={row} />,
      size: 50,
      enableSorting: false,
    },
  ]
}
